import _ from "lodash";
import store from "@/store";
import GridProfileRepository from "@/repositories/GridProfileRepository";

export interface GridProfile {
    grids: {
        lg: string;
        md: string;
        sm: string;
    };
    widgets: {
        gridArea: string;
        type: string;
        parameters: object;
    };
}

export default {
    state: {
        gridProfile: null,
    },
    mutations: {
        setGridProfile: (state: any, gridProfile: GridProfile) => {
            _.set(state, "gridProfile", gridProfile);
        },
    },
    getters: {
        getGridProfile: (state: { gridProfile: GridProfile | null }): GridProfile | null => {
            return state.gridProfile;
        },
    },
    actions: {
        loadGridProfile: ({commit}: any): Promise<void> => {
            return new Promise((resolve, reject) => {
                GridProfileRepository
                    .get({
                        filters: {
                            ownerUuid: _.get(store.getters, "getCurrentOwnerUuid", ""),
                        }
                    })
                    .then((data: object[]) => {
                        commit("setGridProfile", data[0]);
                        resolve();
                    })
                    .catch(() => {
                        commit("setGridProfile", null);
                        reject();
                    });
            });
        },
    },
};
